// extracted by mini-css-extract-plugin
export default {"actions__content":"OrgActionCell_actions__content__C4NQ3","icon":"OrgActionCell_icon__BmiQS"};